import ItemHelper from "../Item/ItemHelper";
import ItemViewHelper from "../Item/ItemViewHelper";
import Utils from "../../../../utils/Utils";
import {OrderType} from "../../../Api/types";

class StateItemHelper {
    static create = (id: any, items: any, modiferGroups: any, orderType: OrderType | string | undefined, currentItem?: any, modifierGroupId?: any, parentItemId?: any) => {

        if (currentItem && currentItem.item_id === id) {
            return undefined;
        }
        let item = ItemHelper.getItem(items, id);
        if (item === undefined) {
            return undefined;
        }
        if (currentItem === undefined) {
            currentItem = {
                name: undefined,
                quantity: 1,
                modifier_groups: [],
                price: 0,
                unit_total_price: 0,
                total_price: 0
            }
        }
        let itemPrice = item.price !== undefined ? item.price.amount : 0;
        let itemPriceOvveride = item.price_info_overrides.filter((x: any) => x.context_type == "ITEM" && x.context_id == parentItemId)[0];
        if (itemPriceOvveride !== undefined && itemPriceOvveride) {
            itemPrice = itemPriceOvveride.price.amount;
        } else {
            let modifierGroupPriceOvveride = item.price_info_overrides.filter((x: any) => x.context_type == "MODIFIER_GROUP" && x.context_id == modifierGroupId)[0];
            if (modifierGroupPriceOvveride !== undefined && modifierGroupPriceOvveride) {
                itemPrice = modifierGroupPriceOvveride.price.amount;
            }
        }

        let stateItem = {
            item_id: item.id,
            price: itemPrice,
            name: item.translation.name,
            unit_total_price: itemPrice,
            total_price: itemPrice,
            quantity: currentItem.quantity,
            modifier_groups: []
        } as any
        if (modifierGroupId) {
            stateItem.parent_modifier_group_id = modifierGroupId;
        }
        item.modifier_groups.forEach((itemModifierGroup: any) => {
            let modifierGroup = ItemHelper.getModifierGroup(modiferGroups, itemModifierGroup.modifier_group_id);

            if (modifierGroup === undefined) {
                return;
            }
            let stateModifierGroup = {
                selected_items: [] as any[],
                modifier_group_id: modifierGroup.id
            }

            modifierGroup.options.forEach((modifierGroupOption: any) => {
                let modifierGroupItem = ItemHelper.getItem(items, modifierGroupOption.entity_id);

                if (modifierGroupItem !== undefined) {

                    let quantityInfo = ItemHelper.getItemQuantityInfo(modifierGroupItem, item, modifierGroup);

                    if (quantityInfo !== undefined && (quantityInfo.default_quantity > 0 || quantityInfo.min_permitted > 0)) {

                        if (modifierGroupItem.order_types !== undefined && modifierGroupItem.order_types.length > 0 && !modifierGroupItem.order_types.includes(orderType)) {
                            return;
                        }

                        const stateModifierGroupItemPrice = ItemHelper.getPriceOvveride(modifierGroupItem, item, modifierGroup);
                        const quantity = Utils.zeroIfNull(quantityInfo.default_quantity) > 0 ? quantityInfo.default_quantity : quantityInfo.min_permitted ?? 0;
                        const stateModifierGroupItemObject = StateItemHelper.createSubItem(modifierGroupItem.id, items, modiferGroups, currentItem, modifierGroup.id, id, quantity, orderType);
                        const stateModifierGroupItem = stateModifierGroupItemObject?.stateItem;
                        const isAnyOptionCustomizable = stateModifierGroupItemObject?.isCustomize;

                        if (stateModifierGroupItemPrice !== stateModifierGroupItem.price) {
                            throw new Error('stateModifierGroupItemPrice !== stateModifierGroupItem.price');
                        }

                        let isCustomize = false;
                        let isStandalone = quantityInfo.min_permitted === 1 && quantityInfo.min_permitted === quantityInfo.max_permitted && modifierGroup.options.length === 1;
                        let isChangeQuantity = true;

                        if ((quantityInfo.min_permitted === quantityInfo.max_permitted && quantityInfo.min_permitted === quantityInfo.default_quantity)) {
                            isChangeQuantity = false;
                        }

                        if (!isCustomize) {
                            if (isAnyOptionCustomizable) {
                                isCustomize = true;
                            }
                            if (isChangeQuantity) {
                                if ((isStandalone && quantityInfo.default_quantity === 1) || !modifierGroupItem.modifier_groups.length) {
                                } else {
                                    isCustomize = true;
                                }
                            }
                        }

                        if (isCustomize) {
                            for (let i = 0; i < stateModifierGroupItem.quantity; i++) {
                                const clonedStateModifierGroup = JSON.parse(JSON.stringify(stateModifierGroupItem));
                                clonedStateModifierGroup.quantity = 1;
                                stateModifierGroup.selected_items.push(clonedStateModifierGroup);
                            }
                        } else {
                            stateModifierGroup.selected_items.push(stateModifierGroupItem);
                        }
                    }
                }
            })

            StateItemHelper.updateStateSelectedItemsChargeAbove(stateModifierGroup.selected_items, items, item, modifierGroup);
            if (stateModifierGroup.selected_items.length > 0) {
                stateItem.modifier_groups.push(stateModifierGroup);
            }
        })

        StateItemHelper.refreshPrice(stateItem);
        return stateItem;
    }

    static createSubItem = (id: any, items: any, modiferGroups: any, currentItem: any, modifierGroupId: any, parentItemId: any, itemQuantity: any, orderType: OrderType | string | undefined) => {
        let item = ItemHelper.getItem(items, id);
        if (item === undefined) {
            return undefined;
        }
        let itemPrice = item.price !== undefined ? item.price.amount : 0;
        let itemPriceOvveride = item.price_info_overrides.filter((x: any) => x.context_type == "ITEM" && x.context_id == parentItemId)[0];
        if (itemPriceOvveride !== undefined && itemPriceOvveride) {
            itemPrice = itemPriceOvveride.price.amount;
        } else {
            let modifierGroupPriceOvveride = item.price_info_overrides.filter((x: any) => x.context_type == "MODIFIER_GROUP" && x.context_id == modifierGroupId)[0];
            if (modifierGroupPriceOvveride !== undefined && modifierGroupPriceOvveride) {
                itemPrice = modifierGroupPriceOvveride.price.amount;
            }
        }

        let stateItem = {
            item_id: item.id,
            price: itemPrice,
            name: item.translation.name,
            unit_total_price: itemPrice,
            total_price: itemPrice,
            quantity: itemQuantity,
            modifier_groups: []
        } as any
        if (modifierGroupId) {
            stateItem.parent_modifier_group_id = modifierGroupId;
        }
        let anyCustomizeItem = false;
        item.modifier_groups.forEach((itemModifierGroup: any) => {
            let modifierGroup = ItemHelper.getModifierGroup(modiferGroups, itemModifierGroup.modifier_group_id);
            if (modifierGroup === undefined) {
                return;
            }
            let stateModifierGroup = {
                selected_items: [] as any[],
                modifier_group_id: modifierGroup.id
            }

            modifierGroup.options.forEach((modifierGroupOption: any) => {
                let modifierGroupItem = ItemHelper.getItem(items, modifierGroupOption.entity_id);
                if (modifierGroupItem !== undefined) {

                    if (modifierGroupItem.order_types !== undefined && modifierGroupItem.order_types.length > 0 && !modifierGroupItem.order_types.includes(orderType)) {
                        return;
                    }

                    let quantityInfo = ItemHelper.getItemQuantityInfo(modifierGroupItem, item, modifierGroup);
                    if (quantityInfo !== undefined && (quantityInfo.default_quantity > 0 || quantityInfo.min_permitted > 0)) {

                        let stateModifierGroupItemPrice = ItemHelper.getPriceOvveride(modifierGroupItem, item, modifierGroup);
                        let quantity = Utils.zeroIfNull(quantityInfo.default_quantity) > 0 ? quantityInfo.default_quantity : quantityInfo.min_permitted ?? 0;

                        const stateModifierGroupItemObject = StateItemHelper.createSubItem(modifierGroupItem.id, items, modiferGroups, currentItem, modifierGroup.id, id, quantity, orderType);
                        const stateModifierGroupItem = stateModifierGroupItemObject?.stateItem;

                        if (stateModifierGroupItemPrice !== stateModifierGroupItem.price) {
                            throw new Error('stateModifierGroupItemPrice !== stateModifierGroupItem.price');
                        }

                        let isCustomize = false;
                        let isStandalone = quantityInfo.min_permitted === 1 && quantityInfo.min_permitted === quantityInfo.max_permitted && modifierGroup.options.length === 1;
                        let isChangeQuantity = true;

                        if ((quantityInfo.min_permitted === quantityInfo.max_permitted && quantityInfo.min_permitted === quantityInfo.default_quantity)) {
                            isChangeQuantity = false;
                        }
                        if (!isCustomize) {
                            if (isChangeQuantity) {
                                if (isStandalone && quantityInfo.default_quantity === 1) {
                                } else {
                                    isCustomize = true;
                                }
                            }
                        }

                        if (!anyCustomizeItem && isCustomize) anyCustomizeItem = true;

                        stateModifierGroup.selected_items.push(stateModifierGroupItem);
                    }
                }
            })

            StateItemHelper.updateStateSelectedItemsChargeAbove(stateModifierGroup.selected_items, items, item, modifierGroup);
            if (stateModifierGroup.selected_items.length > 0) {
                stateItem.modifier_groups.push(stateModifierGroup);
            }
        });
        StateItemHelper.refreshPrice(stateItem);
        return {stateItem, isCustomize: anyCustomizeItem};
    }

    static refreshPrice = (item: any) => {
        if (item === undefined) {
            return;
        }
        let total_price = 0;
        total_price = item.modifier_groups.map((modifierGroup: any) => {
            let modifierGroupPrice = modifierGroup.selected_items.reduce((prev: any, next: any) => prev + next.total_price, 0);
            return modifierGroupPrice;
        }).reduce((prev: any, next: any) => prev + next, 0);
        item.unit_total_price = item.price + total_price;
        item.total_price = item.unit_total_price * item.quantity;
    }
    static refreshItemPrice = (item: any, itemPromotions: any, cart: any) => {
        if (item === undefined) {
            return;
        }
        let total_price = 0;
        total_price = item.modifier_groups.map((modifierGroup: any) => {
            let modifierGroupPrice = modifierGroup.selected_items.reduce((prev: any, next: any) => prev + next.total_price, 0);
            return modifierGroupPrice;
        }).reduce((prev: any, next: any) => prev + next, 0);
        item.unit_total_price = item.price + total_price;
        item.total_price = item.unit_total_price * item.quantity;
        let discountedPrice = ItemViewHelper.getDiscountPrice(item.item_id, item.quantity, item.unit_total_price, itemPromotions, cart, item.price);
        item.discount_price = discountedPrice;
    }
    static refreshItemPriceWithParent = (stateItem: any, itemPromotions: any, cart: any, parentModifierGroupId: any, items: any, modifier_groups: any) => {
        StateItemHelper.refreshItemPrice(stateItem, itemPromotions, cart);
        if (parentModifierGroupId) {
            StateItemHelper.refreshStateModifierGroupItemOption(stateItem, parentModifierGroupId, items, modifier_groups);
        }
    }
    static updateStateSelectedItemsChargeAbove = (stateSelectedItems: any, items: any, parentItem: any, modifierGroup: any) => {
        let modifierGroupQuantityInfo = ItemHelper.getModifierGroupQuantityInfo(modifierGroup, parentItem);
        stateSelectedItems.forEach((stateSelectedItem: any) => {
            StateItemHelper.updateStateSelectedItemChargeAbove(stateSelectedItem, items, parentItem, modifierGroup);
        });
        if (modifierGroupQuantityInfo !== undefined && modifierGroupQuantityInfo.charge_above > 0) {
            let chargeAboveQuantity = modifierGroupQuantityInfo.charge_above;
            if (chargeAboveQuantity) {
                [...[...stateSelectedItems]
                    .sort((a: any, b: any) => {
                        const aItem = items.find((item: any) => item.id === a.item_id)
                        const bItem = items.find((item: any) => item.id === b.item_id)
                        const aQuantityInfo = ItemHelper.getItemQuantityInfo(aItem, parentItem, modifierGroup);
                        const bQuantityInfo = ItemHelper.getItemQuantityInfo(bItem, parentItem, modifierGroup);
                        if (aQuantityInfo?.min_permitted > 0 && bQuantityInfo?.min_permitted > 0) return 0;
                        if (aQuantityInfo?.min_permitted > 0) return -1;
                        if (bQuantityInfo?.min_permitted > 0) return 1;
                        return a.price - b.price;
                    })].forEach((stateSelectedItem: any) => {
                    if (chargeAboveQuantity <= 0) {
                        return;
                    }

                    const maxQuantityFree = Math.min(stateSelectedItem.quantity, chargeAboveQuantity);
                    chargeAboveQuantity = chargeAboveQuantity - maxQuantityFree;
                    stateSelectedItem.quantity_free = maxQuantityFree;
                    const chargeQuantity = stateSelectedItem.quantity - maxQuantityFree;
                    stateSelectedItem.total_price = stateSelectedItem.price * chargeQuantity;
                });
            }
        }
    }

    static updateStateSelectedItemChargeAbove = (stateSelectedItem: any, items: any, parentItem: any, modifierGroup: any) => {
        // let totalPrice = stateSelectedItem.total_price;
        let totalPrice = stateSelectedItem.unit_total_price * stateSelectedItem.quantity;
        let selectedItem = ItemHelper.getItem(items, stateSelectedItem.item_id);
        let selectedItemQuantityInfo = ItemHelper.getItemQuantityInfo(selectedItem, parentItem, modifierGroup);
        if (selectedItemQuantityInfo !== undefined && selectedItemQuantityInfo.charge_above > 0) {
            let quantityChargeAbove = stateSelectedItem.quantity - selectedItemQuantityInfo.charge_above;
            quantityChargeAbove = quantityChargeAbove > 0 ? quantityChargeAbove : 0;
            let quantityChargeBelow = stateSelectedItem.quantity - quantityChargeAbove;
            totalPrice = 0;
            if (quantityChargeAbove > 0) {
                totalPrice = stateSelectedItem.unit_total_price * quantityChargeAbove;
            }
            stateSelectedItem.quantity_free = quantityChargeBelow;
        } else {
            stateSelectedItem.quantity_free = 0;
        }
        stateSelectedItem.total_price = totalPrice;
    }
    static getOrCreateStateModifierGroup = (stateItem: any, modifierGroupId: any) => {
        let modifierGroup = stateItem.modifier_groups.filter((modifierGroup: any) => modifierGroup.modifier_group_id === modifierGroupId)[0];
        if (modifierGroup === undefined) {
            modifierGroup = {
                modifier_group_id: modifierGroupId,
                selected_items: []
            };
            stateItem.modifier_groups.push(modifierGroup);
        }
        return modifierGroup;
    }
    static getOrCreateStateModifierGroupItemOption = (stateItem: any, modifierGroupId: any, item: any, items: any, modifier_groups: any, orderType: string | undefined) => {
        let modifierGroup = StateItemHelper.getOrCreateStateModifierGroup(stateItem, modifierGroupId);
        let modifierGroupItem = modifierGroup.selected_items.filter((selectedItem: any) => selectedItem.item_id === item.id)[0];
        if (modifierGroupItem === undefined) {
            modifierGroupItem = StateItemHelper.create(item.id, items, modifier_groups, orderType, undefined, modifierGroupId, stateItem.item_id);
            modifierGroup.selected_items.push(modifierGroupItem);
        }

        return modifierGroupItem;
    }

    static setQuantityItem = (stateItem: any, modifierGroup: any, item: any, quantity: any, items: any, modifier_groups: any, orderType: string | undefined) => {
        if (modifierGroup.min_permitted === 1 && modifierGroup.max_permitted === 1) {
            let stateModifierGroup = StateItemHelper.getOrCreateStateModifierGroup(stateItem, modifierGroup.id);
            stateModifierGroup.selected_items = [];
        }
        let modifierGroupItem = StateItemHelper.getOrCreateStateModifierGroupItemOption(stateItem, modifierGroup.id, item, items, modifier_groups, orderType);
        modifierGroupItem.quantity = quantity;
        modifierGroupItem.total_price = modifierGroupItem.unit_total_price * modifierGroupItem.quantity;
        StateItemHelper.refreshStateModifierGroupItemOption(stateItem, modifierGroup.id, items, modifier_groups);
    }
    static setItemOption = (stateItem: any, modifierGroupId: any, itemId: any, quantity: any, items: any, modifier_groups: any, id: any, orderType: string | undefined) => {
        let stateModifierGroup = StateItemHelper.getOrCreateStateModifierGroup(stateItem, modifierGroupId);
        let selectedItem = stateModifierGroup.selected_items[id - 1];
        let modifierGroupItem = StateItemHelper.create(itemId, items, modifier_groups, orderType, undefined, modifierGroupId, stateItem.item_id);
        modifierGroupItem.quantity = quantity;
        modifierGroupItem.total_price = modifierGroupItem.unit_total_price * modifierGroupItem.quantity;

        if (selectedItem === undefined) {
            stateModifierGroup.selected_items.push(modifierGroupItem);
        } else {
            stateModifierGroup.selected_items[id - 1] = modifierGroupItem;
        }
        StateItemHelper.refreshStateModifierGroupItemOption(stateItem, modifierGroupId, items, modifier_groups);
    }
    static refreshStateModifierGroupItemOption = (stateItem: any, modifierGroupId: any, items: any, modifier_groups: any) => {
        let stateModifierGroup = StateItemHelper.getOrCreateStateModifierGroup(stateItem, modifierGroupId);
        let modifierGroup = ItemHelper.getModifierGroup(modifier_groups, modifierGroupId);
        stateModifierGroup.selected_items = stateModifierGroup.selected_items.filter((selectedItem: any) => selectedItem.quantity > 0);

        let item = ItemHelper.getItem(items, stateItem.item_id);
        StateItemHelper.updateStateSelectedItemsChargeAbove(stateModifierGroup.selected_items, items, item, modifierGroup);

        if (stateModifierGroup.selected_items.length <= 0) {
            stateItem.modifier_groups = stateItem.modifier_groups.filter((itemModifierGroup: any) => itemModifierGroup.modifier_group_id !== stateModifierGroup.id);
        }
    }
}

export default StateItemHelper;